module.exports = __webpack_public_path__ + "img/mastercard-logo.4eed6d44.png";